import React from 'react';

import { theme } from '@waglabs/base-theme';
import {
  Box,
  BoxProps,
} from '@waglabs/box-next';

export type FieldLabelProps = BoxProps;
export const FieldLabel = ({
  checked,
  ...rest
}: FieldLabelProps) => (
  <Box
    as="label"
    {...rest}
    alignItems="center"
    justifyContent="center"
    borderRadius="8px"
    py="8px"
    boxShadow="0 0 6px 0 rgb(0 0 0 / 20%)"
    cursor="pointer"
    color={theme.colors.charcoal}
    {...checked && {
      border: `2px solid ${theme.colors.funBlue}`,
      boxShadow: 'unset',
      position: 'relative',
    }}
  />
);
